module.exports = function() {
  return new Worker(__webpack_public_path__ + "687b214c0b6fe476cc06.worker.js");
};